import React, { Component } from "react";
import { Marker, Popup } from "react-leaflet";
import { Link, withRouter } from "react-router-dom";
import {
  DefectEscalatorIcon,
  EscalatorIcon,
  iconEscalator,
  iconEscalatorDefect,
  InformationIcon,
  LocationAIcon,
  LocationBIcon,
} from "../icons/Icons";

import "../styles/Marker.css";

class EscalatorMarker extends Component {
  render() {
    let escalator = this.props.escalator;
    let station = this.props.station;
    if (escalator.coords.lat == null || escalator.coords.long == null) {
      return <div></div>;
    }
    return (
      <Marker
        position={[escalator.coords.lat, escalator.coords.long]}
        icon={escalator.isWorking === 1 ? iconEscalator : iconEscalatorDefect}
      >
        <Popup className="marker">
          <h5>{escalator.name}</h5>
          {escalator.additionalInfo ? (
            <p
              dangerouslySetInnerHTML={{ __html: escalator.additionalInfo }}
            ></p>
          ) : null}
          {escalator.isWorking ? (
            <div className="icon working">
              <EscalatorIcon height="30px" /> In Betrieb
            </div>
          ) : (
            <div className="icon">
              <DefectEscalatorIcon height="30px" /> Außer Betrieb
            </div>
          )}
          <Link
            to={{
              pathname: "/accessible",
              state: {
                station: station,
                return: "/",
              },
            }}
            className="information"
          >
            <InformationIcon style={{ height: "30px" }} /> Infos zu Aufzügen und
            Fahrtreppen
          </Link>
          <div className="links">
            <div
              className="btn"
              onClick={() => {
                this.props.setOrigin({
                  type: "coord",
                  name: escalator.name,
                  id:
                    "coord:" +
                    escalator.coords.long * 1000000 +
                    ":" +
                    escalator.coords.lat * 1000000 +
                    ":WGS84",
                  quality: "1000",
                  coords: {
                    lat: escalator.coords.lat,
                    long: escalator.coords.long,
                  },
                });
                this.props.history.push("/");
              }}
              onTouchEnd={() => {
                this.props.setOrigin({
                  type: "coord",
                  name: escalator.loc.name,
                  id:
                    "coord:" +
                    escalator.coords.long * 1000000 +
                    ":" +
                    escalator.coords.lat * 1000000 +
                    ":WGS84",
                  quality: "1000",
                  coords: {
                    lat: escalator.coords.lat,
                    long: escalator.coords.long,
                  },
                });
                this.props.history.push("/");
              }}
            >
              <p>Von hier</p>
              <LocationAIcon style={{ height: "40px" }} />
            </div>
            <div
              className="btn"
              onClick={() => {
                this.props.setDestination({
                  type: "coord",
                  name: escalator.name,
                  id:
                    "coord:" +
                    escalator.coords.long * 1000000 +
                    ":" +
                    escalator.coords.lat * 1000000 +
                    ":WGS84",
                  quality: "1000",
                  coords: {
                    lat: escalator.coords.lat,
                    long: escalator.coords.long,
                  },
                });
                this.props.history.push("/");
              }}
              onTouchEnd={() => {
                this.props.setDestination({
                  type: "coord",
                  name: escalator.name,
                  id:
                    "coord:" +
                    escalator.coords.long * 1000000 +
                    ":" +
                    escalator.coords.lat * 1000000 +
                    ":WGS84",
                  quality: "1000",
                  coords: {
                    lat: escalator.coords.lat,
                    long: escalator.coords.long,
                  },
                });
                this.props.history.push("/");
              }}
            >
              <p>Hierher</p>
              <LocationBIcon style={{ height: "40px" }} />
            </div>
          </div>
        </Popup>
      </Marker>
    );
  }
}

export default withRouter(EscalatorMarker);
